import { goto } from '$app/navigation';
import { base } from '$app/paths';

import { appPath } from '$lib/utils/appPaths';

export const appHref = (path = '/') => appPath(path, base);

export const gotoApp = (path = '/', options?: Parameters<typeof goto>[1]) =>
	goto(appHref(path), options);
